import { render } from "./UsersManagers.vue?vue&type=template&id=3d7faf36&scoped=true"
import script from "./UsersManagers.vue?vue&type=script&lang=js"
export * from "./UsersManagers.vue?vue&type=script&lang=js"

import "./UsersManagers.vue?vue&type=style&index=0&id=3d7faf36&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7faf36"]])

export default __exports__